import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {Subscription} from 'rxjs';
import {HydraService} from '../../../core/services/hydra.service';
import {ToolsService} from '../../services/tools/tools.service';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-nommer-expert',
    templateUrl: './modal-nommer-expert.component.html',
    styleUrls: ['./modal-nommer-expert.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatSelect, MatOption, MatDialogActions, MatDialogClose, MatButton, TranslateModule]
})
export class ModalNommerExpertComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    private toolService = inject(ToolsService);
    private hydraService = inject(HydraService);
    private _formBuilder = inject(UntypedFormBuilder);
    dialogRef = inject<MatDialogRef<ModalNommerExpertComponent>>(MatDialogRef);

    constructor() {}

    public expert = [];
    firstFormGroup: UntypedFormGroup = new UntypedFormGroup({});
    public countries = [];
    private subscriptions: Subscription[] = [];

    ngOnInit() {
        this.firstFormGroup = this._formBuilder.group({
            email: [''],
            nom: ['', [Validators.required]],
            prenom: ['', [Validators.required]],
            ville: ['', [Validators.required]],
            pays: ['', Validators.required],
        });
        this.getCountries();
    }

    public compareByCode(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.code == itemTwo.code;
    }

    getCountries() {
        this.subscriptions.push(
            this.hydraService
                .getList(api.countries, true)
                .subscribe((res: HydraCollection) => {
                    this.countries = res.getMember();
                })
        );
    }

    public addExpert() {
        const dossier = this.data;
        let data = { ...this.firstFormGroup.getRawValue(), dossier };
        data = this.hydraService.beforeSaveHydraRelation(data, ['pays']);
        this.hydraService.post(api.expertSuggestion, data).subscribe(res => {
            this.toolService.notificationInfo(
                'Votre demande a été envoyée',
                3000
            );
            this.dialogRef.close(
                res
            );
        });
    }

    get email() {
        return this.firstFormGroup.get('email');
    }
    get nom() {
        return this.firstFormGroup.get('nom');
    }
    get prenom() {
        return this.firstFormGroup.get('prenom');
    }
    get ville() {
        return this.firstFormGroup.get('ville');
    }
    get pays() {
        return this.firstFormGroup.get('pays');
    }
}
